import { render, staticRenderFns } from "./GeneralAndParametersLayout.vue?vue&type=template&id=0c461bfc&"
import script from "./GeneralAndParametersLayout.vue?vue&type=script&lang=js&"
export * from "./GeneralAndParametersLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports